/**
 * Prefixes a path with the Vite app base (e.g. /ex4) for native anchors and new-tab links
 * that bypass React Router's basename.
 */
export function withAppBasePath(path: string): string {
  const baseUrl = import.meta.env.BASE_URL || '/';
  const normalizedBase = baseUrl.replace(/^\/+|\/+$/g, '');
  return normalizedBase ? `/${normalizedBase}${path}` : path;
}
